<template>
    <li class="c-thumbnail-list__item c-thumbnail-list__item-4">
        <a :href="getContentsUrl(plusItem.id, plusItem.plus_category_id)">
            <div class="c-thumbnail-list__img search_plus_list">
                <webp-picture :webp="plusItem.webp_thumbnail_url" class="inherit">
                    <img loading="lazy" :src="plusItem.image_thumbnail_url" alt="">
                </webp-picture>
            </div>
            <div class="c-thumbnail-list__text">
                <p class="c-bookname">{{ plusItem.talent_names }}</p>
                <p class="c-booktitle text-truncate2">{{ $filters.truncate(plusItem.title, 21, "...") }}</p>
                <div class="c-thumbnail-list__icon">
                    <div class="c-label-new" v-if="plusItem.is_new == true">New</div>
                    <div v-if="isGravure(plusItem.plus_category_id)" class="c-label-limited c-label-pink">＋Weekly</div>
                    <div v-if="isMovie(plusItem.plus_category_id)" class="c-label-limited c-label-pink">＋Weekly</div>
                    <div v-if="isArchives(plusItem.plus_category_id)" class="c-label-limited c-label-pink">＋Special</div>
                    <div v-if="isColumn(plusItem.plus_category_id)" class="c-label-limited c-label-pink">コラム</div>
                </div>
            </div>
        </a>
    </li>
</template>

<script>
import routeMixin from '../../mixins/route.js';
export default {
//    name: "PlusItemList",
    props: [
        'route_list',
        'plusItem',
    ],
    mixins: [routeMixin],
    data() {
        return {
        }
    },
    methods : {
        getContentsUrl: function (id, value) {
            if (!value) {
                return this.route(this.route_list, 'site.plus.archives.detail', {id:id});
            } else if (value === 2) {
                return this.route(this.route_list, 'site.plus.weekly.show', {id:id});
            } else if (value === 1) {
                return this.route(this.route_list, 'site.plus.weekly.show', {id:id});
            } else {
                return this.route(this.route_list, 'site.plus.column.contents', {category_id:value, id:id});
            }
        },
        isGravure : function(category) {
            return category === 2;
        },
        isMovie : function(category) {
            return category === 1;
        },
        isArchives : function(category) {
            return !category;
        },
        isColumn : function(category) {
            return category > 2;
        }
    }
}
</script>

<style scoped>

</style>
